import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { bookCategoeyEnums, bookCategories } from '../shared/models/shelfEnums';

@Pipe({
    name: 'FilterArrayPipe'
})
@Injectable()
export class FilterArrayPipe {
    bookCategoeyEnums = bookCategoeyEnums;
    bookCategoryTypes = bookCategories;
    transform(value, args) {

        if (!args) {
            return value;
        }
        else if (value) {
            return value.filter(item => {
                for (let key in item) {


                    // if(item.recent && args == 'Recent'){

                    //     return true;
                    // }
                    // if(args == 'EBE'){

                    var value = this.bookCategoryTypes[this.bookCategoeyEnums[item.bookType]]

                    if (value == args) {
                        return true;
                    }
                    // }
                    // if(args == 'ELE'){
                    //     if(item.bookType == 'ELE'){
                    //         return true;
                    //     }
                    // }

                    // if (item.type == args) {                       
                    //     return true;
                    // }
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shelf/filter.pipe.ts